import React from 'react'
import { Grid, Button  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    submit: {
        margin: (3, 0, 2),
        fontWeight: 'bold',
        fontSize: '0.6rem',
        borderLeft: '3px solid rgba(255, 198, 0)',
        color: '#1a1919',
        backgroundColor: "#ffffff",
        fontFamily: 'Ubuntu',
        "&:hover": {
            backgroundColor: "#ffffff",
            borderLeft: '3px solid rgba(255, 198, 0)',
        }
    },
}));

const validate = values => {
    const error  = {}
    //console.log(values)
    return error
}

const required = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if(AgreementForm.length > 0){

        if(!value){
            return `${AgreementForm[0].label} es requerido(a).`
        }else{
            return undefined
        }
    }else{
        return undefined
    }
}

const maxLengthReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if(AgreementForm.length > 0){

        if(value.length > parseInt(AgreementForm[0].maxLength)){
            return `Debe tener ${AgreementForm[0].maxLength} carácteres o menos.`
        }else{
            return undefined
        }
    }else{
        return undefined
    }
}

const validateReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if(AgreementForm.length > 0){

        let exp = new RegExp(AgreementForm[0].pattern);

        if(exp.test(value) === false){
            return AgreementForm[0].messageValidationPattern
        }else{
            return undefined
        }
    }else{
        return undefined
    }
    
}

const ServiceSwitchForm = props => {

    const classes = useStyles();

    const { 
            handleSubmit, 
            agreementsSelected, 
            setAgreementsSelected, 
            agreements, 
            onCancelAction,
            titleSelectAgreement,
            titleLabelReference, 
            invalid 
        } = props

    return (
        <div>
            <form className={classes.form} onSubmit={ handleSubmit }>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Autocomplete
                            id="combo-box-demo"
                            value={ agreementsSelected }
                            options={ agreements }
                            disableClearable
                            getOptionLabel={(option) => (option.name) ? option.name : ""}
                            style={{ width: '100%' }}
                            onChange = { (e, nv) => {
                                            setAgreementsSelected(nv)
                                        }}
                            renderInput={(params) => <TextField {...params} label={ titleSelectAgreement } variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        
                        <Field
                            name="reference"
                            id="reference"
                            validate = { [required, validateReference, maxLengthReference]}
                            autoFocus = { true }
                            component={ RenderTextFieldRedux }
                            label= {titleLabelReference}
                            fullWidth
                        />
                        
                    </Grid>
                    
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            fullWidth
                            className={classes.submit}
                            disabled={ invalid }
                            >
                            Consultar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6}>
                        <Button variant="contained" fullWidth className={classes.submit} onClick = { () => onCancelAction() }>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const ServiceSwitchFormReduxForm = reduxForm(
    {
        form: 'ServiceSwitchForm',
        validate
    }
)(ServiceSwitchForm)
export default ServiceSwitchFormReduxForm
